import ProcessFieldDynamicDisplay from '@shared/components/ProcessFieldDynamic/ProcessFieldDynamicDisplay';

import { ShadcnForm } from '@shadcn-features/core';
import { useEffect } from 'react';

type ProcessFieldDynamicDisplayWebComponentsProps =
    React.ComponentPropsWithoutRef<typeof ProcessFieldDynamicDisplay> & {
        value?: unknown;
        defaultValues?: Record<string, unknown>;
        onValueChange?: (value: unknown) => void;
    };

function ProcessFieldValueObserver({
    name,
    onValueChange,
}: {
    name: string;
    onValueChange?: (value: unknown) => void;
}) {
    const value = ShadcnForm.useWatch(name);

    useEffect(() => {
        onValueChange?.(value);
    }, [onValueChange, value]);

    return null;
}

export const ProcessFieldDynamicDisplayWebComponents = ({
    value,
    defaultValues,
    onValueChange,
    ...props
}: ProcessFieldDynamicDisplayWebComponentsProps) => {
    const name = props.name ?? props.field?.id ?? props.processFieldId;
    const initialValues =
        value !== undefined
            ? { ...defaultValues, [name]: value }
            : defaultValues;

    return (
        <ShadcnForm defaultValues={initialValues} mode='onChange'>
            <ProcessFieldValueObserver
                name={name}
                onValueChange={onValueChange}
            />
            <ProcessFieldDynamicDisplay {...props} />
        </ShadcnForm>
    );
};
